import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import LanguageSwitcher from './LanguageSwitcher';
import {
  LayoutDashboard,
  CreditCard,
  User,
  MapPin,
  Wallet,
  Award,
  HelpCircle,
  LogOut
} from 'lucide-react';

const Sidebar: React.FC = () => {
  const { user, logout } = useAuth();
  const { t } = useTranslation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const closeSidebar = () => setSidebarOpen(false);

  const navItems = [
    { icon: <LayoutDashboard size={20} />, label: t('common.dashboard'), path: '/dashboard' },
    { icon: <CreditCard size={20} />, label: t('common.smartOrders'), path: '/orders' },
    { icon: <User size={20} />, label: 'Profile Details', path: '/profile' },
    { icon: <MapPin size={20} />, label: 'Shipping Addresses', path: '/settings/addresses' },
    { icon: <Wallet size={20} />, label: 'Payment Cards', path: '/settings/payment-cards' },
    { icon: <Award size={20} />, label: 'Partner Program Card', path: '/settings/partner-program' },
    { icon: <HelpCircle size={20} />, label: 'Help Center', path: '/settings/help' },
  ];

  return (
    <>
      <button
        className={`sidebar-hamburger ${sidebarOpen ? 'open' : ''}`}
        onClick={() => setSidebarOpen(!sidebarOpen)}
        aria-label="Toggle sidebar"
      >
        <span className="hamburger-line" />
        <span className="hamburger-line" />
        <span className="hamburger-line" />
      </button>

      {sidebarOpen && (
        <div className="sidebar-overlay show" onClick={closeSidebar} />
      )}

      <div className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <NavLink to="/dashboard" className="sidebar-logo" onClick={closeSidebar}>
          IncordUK
        </NavLink>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <NavLink 
              key={item.path} 
              to={item.path} 
              className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
              onClick={closeSidebar}
            >
              {item.icon}
              <span>{item.label}</span>
            </NavLink>
          ))}
          <div className="sidebar-item" style={{ cursor: 'default' }}>
            <LanguageSwitcher />
          </div>
        </nav>

        <div className="sidebar-footer">
          <div className="user-profile-mini">
            <div className="user-info-mini">
              <div className="user-name-mini">{user?.full_name || 'User'}</div>
              <div className="user-email-mini">{user?.email}</div>
            </div>
            <button 
              onClick={logout} 
              className="btn-outline" 
              style={{ padding: '8px', minHeight: 'auto' }}
              title="Logout"
            >
              <LogOut size={16} />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
